import { BrowserRouter, Routes, Route, Navigate } from "react-router-dom";
import "@/App.css";

import HomePage from "@/pages/Home";
import SignupPage from "@/pages/Signup";
import FreeSignupPage from "@/pages/FreeSignup";
import WelcomePage from "@/pages/Welcome";
import TermsPage from "@/pages/Terms";
import PrivacyPage from "@/pages/Privacy";
import BriefingPage from "@/pages/Briefing";
import LineupCardPage from "@/pages/LineupCard";

function App() {
  return (
    <div className="App">
      <BrowserRouter>
        <Routes>
          <Route path="/" element={<HomePage />} />
          <Route path="/signup" element={<SignupPage />} />
          <Route path="/free-signup" element={<FreeSignupPage />} />
          <Route path="/welcome" element={<WelcomePage />} />
          <Route path="/terms" element={<TermsPage />} />
          <Route path="/privacy" element={<PrivacyPage />} />
          <Route path="/briefing/:token" element={<BriefingPage />} />
          <Route path="/lineup-card" element={<LineupCardPage />} />
          <Route path="/dailynine" element={<Navigate to="/lineup-card" replace />} />
        </Routes>
      </BrowserRouter>
    </div>
  );
}

export default App;
